import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Joi from "joi-browser";
import SubForm from "../../Components/Comman/SubForm";
import {
    getBprmForm,
    loadBprmForm,
    getStateCountyCity,
    getDataTypeCodemanager,
    saveBprmForm,
    updateBprmForm,
    getUpdateStatus,
    allStatesObjReceived,
    allStateCountyCityReceived,
    formUpdated,
    taskFormSaved,
    getTaskFormSavedStatus
} from "../../app/store/bprmForm";
import { CircularProgress, Button as MUIButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { getApplication, loadApplication, getApplicationData } from "../../app/store/application";
import { workflowTaskDone, executeBprmFormRule, getExecuteRuleAppData, taskDone, getTaskDoneStatus } from "../store/WorkflowEngine";
import Label from "./BprmDynamicControls/Label";
import TextBox from "./BprmDynamicControls/TextBox";
import Dropdown from "./BprmDynamicControls/Dropdown";
import Date from "./BprmDynamicControls/Date";
import Button from "./BprmDynamicControls/Button";
import Multiline from "./BprmDynamicControls/Multiline";
import { getCurrentUser, loadUserDetails } from "../store/auth";
import { getAlert, getAlertWithOk } from "../../Services/appAlerts";
import Radio from "./BprmDynamicControls/Radio";
import FileUpload from "./BprmDynamicControls/FileUpload";
import geoService, { getAllCountries, getStateList } from "../../Services/geoService";
import CheckBox from "./BprmDynamicControls/CheckBox";
import ViewFile from "./BprmDynamicControls/ViewFile";
import { ddrmsViewFileDocsReceived } from "../store/documents";
import { useNavigate } from "react-router-dom";

export default function WorkflowElement(props) {
    const { wfTask, handleNextTask, appSummary,
        viewType, viewTypeType, codeVerified, updatedStateData,
        wfTaskType, saveBtnProcessStatus,
        setSaveBtnProcessStatus,
        workflowFormData, documentInfo, actionType } = props;

    const [stateSchema, setStateSchema] = useState({});
    const [stateData, setStateData] = useState({});
    const [stateErrors, setStateErrors] = useState({});
    const [encryptionDecryptions, setEncryptionDecryptions] = useState({});
    const [wfForm, setWfForm] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [application, setApplication] = useState("");
    const [aWorkfinityAppEntity, setAworkfinityAppEntity] = useState("");
    const [aWorkfinityApp, setAworkfinityApp] = useState("");
    const [stateCountyCity, setStateCountyCity] = useState([]);
    const [subformDataType, setSubformDataType] = useState([]);
    const [ddTypeCodMngr, setDdTypeCodMngr] = useState([]);
    const [frmDDTypes, setFrmDDTypes] = useState([]);
    const [subformItemIndex, setSubformItemIndex] = useState(1);
    const [codeIsVerified, setCodeIsVerified] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [btnProcessStatus, setBtnProcessStatus] = useState(saveBtnProcessStatus);
    const [btnUpdateProcess, setBtnUpdateProcess] = useState(false);
    const [isTaskForm, setIsTaskForm] = useState(false);
    const [saveBtnType, setSaveBtnType] = useState("");
    const [currentButtonType, setCurrentButtonType] = useState("");
    const [currentButtonMessage, setCurrentButtonMessage] = useState("");
    const [isCountryStateChanged, setIsCountryStateChanged] = useState(true);
    const [isEncryptedForm, setIsEncryptedForm] = useState(false);

    const [allCountryList, SetAllCountryList] = useState([]);
    const [allStateList, setAllStateList] = useState([]);
    const [allCountyList, setAllCountyList] = useState([]);
    const [allCityList, setAllCityList] = useState([]);

    const bprmFormSelector = useSelector(getBprmForm);
    const applicationSelector = useSelector(getApplication);
    const ruleAppDataSelector = useSelector(getExecuteRuleAppData);
    const updateStatusSelector = useSelector(getUpdateStatus);
    const taskDoneStatusSelector = useSelector(getTaskDoneStatus);
    const taskFormSavedStatusSelector = useSelector(getTaskFormSavedStatus)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!saveBtnProcessStatus) {
            setBtnProcessStatus(false);
            if (setSaveBtnProcessStatus)
                setSaveBtnProcessStatus(null);
        }
    }, [saveBtnProcessStatus]);

    useEffect(() => {
        if (!wfTask)
            setWfForm(null);

        if (wfTask?.ciid > 0)
            dispatch(loadApplication(wfTask?.ciid));

        if (viewType) {
            setIsDisabled(true);
            setCodeIsVerified(false);
        }
        else {
            //setIsDisabled(false);
            setCodeIsVerified(true);
        }
    }, [wfTask]);

    useEffect(() => {
        if (codeVerified) setCodeIsVerified(true);
    }, [codeVerified]);

    useEffect(() => {
        if (applicationSelector.length > 0) {
            const latestApp = applicationSelector[applicationSelector.length - 1];
            setApplication(latestApp);

            const obj = getApplicationData(latestApp.applicationData);

            if (obj?.aWorkfinityApp)
                setAworkfinityApp(obj.aWorkfinityApp);

            if (obj?.aWorkfinityAppEntity)
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);

            if (workflowFormData && obj?.data && !appSummary) {
                const newData = { ...obj.data, ...workflowFormData };
                setStateData(newData);
            } else if (obj?.data && !appSummary) {
                setStateData(obj.data);
            }

            if (wfTask?.formId > 0)
                dispatch(loadBprmForm(wfTask?.formId));

        } else {
            setAworkfinityApp("");
            setAworkfinityAppEntity("");
            setStateData({});
        }
    }, [applicationSelector]);

    useEffect(() => {
        if (bprmFormSelector.length > 0) {
            if (!bprmFormSelector[0].isEdit && wfTaskType !== "viewForm") setIsDisabled(true);

            setIsEncryptedForm(bprmFormSelector[0].isEncrypted);

            setDocuments([]);
            const loadAllCountry = async () => {
                const allCountry = await getAllCountries();
                SetAllCountryList(allCountry);
            }
            loadAllCountry();
            const loadUsState = async () => {
                const allUsState = await getStateList();
                setAllStateList(allUsState);
            }
            loadUsState();
            setWfForm(bprmFormSelector[0]);
        }
    }, [bprmFormSelector]);

    useEffect(() => {
        if (wfForm !== "") {
            const loadStateCounty = async () => {
                const addResult = await getStateCountyCity(wfForm, stateData);
                const presult = await Promise.all(Object.keys(addResult).map(async (x) => {
                    const obj = addResult[x];
                    if (obj) {
                        const nObj = await Promise.all(obj.stateObjects.map(async (s) => {
                            const nX = { ...s }
                            const rs = await geoService.getGeoData(s.id);
                            nX.list = rs;
                            return nX;
                        }));

                        obj.stateObjects = nObj;

                        const cObj = await Promise.all(obj.countyObjects.map(async (s) => {
                            const stList = nObj.filter(x => x.childCompId === s.compId);
                            if (stList.length > 0) {
                                const stObj = stList[0].list.filter(x => x.name === s.name);
                                if (stObj.length > 0) {
                                    const nX = { ...s }
                                    const rs = await geoService.getGeoData(stObj[0].geonameId);
                                    nX.list = rs;
                                    nX.id = stObj[0].geonameId;
                                    return nX;
                                }
                            }
                        }));

                        obj.countyObjects = cObj;

                        const ccObj = await Promise.all(obj.cityObjects.map(async (s) => {
                            const ctList = cObj.filter(x => x.childCompId === s.compId);
                            if (ctList.length > 0) {
                                const stObj = ctList[0].list.filter(x => x.name === s.name);
                                if (stObj.length > 0) {
                                    const nX = { ...s }
                                    const rs = await geoService.getGeoData(stObj[0].geonameId);
                                    nX.list = rs;
                                    nX.id = stObj[0].geonameId;
                                    return nX;
                                }
                            }
                        }));

                        obj.cityObjects = ccObj;
                    }
                    return obj;
                }));

                dispatch(allStateCountyCityReceived(presult));
                //setStateCountyCity(addResult);
                // setAllStateList(presult);
                // dispatch(allStatesObjReceived(presult));
                const ddResult = await getDataTypeCodemanager(wfForm);
                setDdTypeCodMngr(ddResult.ddTypeCodMngr);
                setSubformDataType(ddResult.subformDataType);
            }
            loadStateCounty();
            setBtnProcessStatus(false);

        }
    }, [wfForm]);

    useEffect(() => {
        setBtnUpdateProcess(false);
        if (updateStatusSelector && actionType === "upd") {
            getAlert("", "Updated Successfully", "success");
            dispatch(formUpdated(false))
            handleNextTask();
        }
        else if (updateStatusSelector) {
            dispatch(formUpdated(false));
        }
    }, [updateStatusSelector]);

    useEffect(() => {
        if (updatedStateData && updatedStateData !== "") {
            const obj = getApplicationData(updatedStateData);
            if (obj?.aWorkfinityApp)
                setAworkfinityApp(obj.aWorkfinityApp);
            if (obj?.aWorkfinityAppEntity)
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);
            if (obj?.data)
                setStateData(obj.data);
        }
        else {
            setStateData({});
        }
    }, [updatedStateData, wfTask]);

    const handleSubformModalShowHide = () => {

    }

    const handleSubformSave = (aWorkfinityAppEntity, subformId) => {
        //setState({ aWorkfinityAppEntity, ["showHide" + subformId]: false });
    };

    const handeOnChange = ({ target: input }) => {
        handleChange(input);
        if (input.dataset?.encryption) {
            addEncryptionFieldData(input.name, input.value);
        }
    };

    const addEncryptionFieldData = (name, value) => {
        const encryp = { ...encryptionDecryptions };
        const data = { ...stateData }
        const newValue = value.replace(/\-/g, "");

        let modifiedValue = "";
        for (let i = 0; i < newValue.length; i++) {
            modifiedValue += "*";
        }
        if (encryp[name + "encrypt"]) {
            data[name] = modifiedValue;
            encryp[name] = encryp[name] + value.replace(/[^\d]/g, "");
        } else {
            data[name] = value.replace(/[^\d]/g, "");
            encryp[name] = modifiedValue;
        }
        setEncryptionDecryptions(encryp);
        setStateData(data);
    };

    const handleEncryptionDecryption = (name) => {
        const updatedData = { ...stateData };
        const encryp = { ...encryptionDecryptions };
        if (encryp[name + "encrypt"]) {
            const actualValue = encryp[name];
            const encryptedValue = updatedData[name];
            encryp[name] = encryptedValue;
            updatedData[name] = actualValue;
            encryp[name + "encrypt"] = false;
        } else {
            const encryptedValue = encryp[name];
            const actualValue = updatedData[name];
            encryp[name] = actualValue;
            updatedData[name] = encryptedValue;
            encryp[name + "encrypt"] = true;
        }
        setEncryptionDecryptions(encryp);
        setStateData(updatedData);
    };

    const handleChange = (input) => {
        const data = { ...stateData };
        const errors = { ...stateErrors };
        const errorMessage = validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];
        data[input.name] = input.value;
        setStateData(data);
        setStateErrors(errors);
    };

    const onFileChange = (event) => {
        const docs = [...documents];
        const data = { ...stateData };

        const docIndex = docs.findIndex((x) => x.refId === event.target.name);
        if (docIndex > -1) {
            docs.splice(docIndex, 1);
        }
        let indx = 0;
        if (docs.length > 0) {
            indx = docs[docs.length - 1].id;
        }
        for (const file of event.target.files) {
            indx += 1;
            const ext = file.name.split(".");
            var doc = {
                id: indx,
                name: file.name,
                newName: file.name,
                type: file.type,
                file: file,
                refId: event.target.name,
                extension: ext.length > 1 ? ext[1] : "",
            };
            docs.push(doc);
        }

        data[event.target.id] = event.target.files[0].name;
        validateDocuments(docs);
        setDocuments(docs);
        setStateData(data);
    };

    const validateDocuments = (docs) => {
        const errors = { ...stateErrors };
        const data = { ...stateData };
        if (docs.length > 0) {
            data["docs"] = docs.length.toString();
            delete errors["docs"];
        } else {
            const obj = { schedule: "" };
            const schema = { schedule: stateSchema["docs"] };
            const { error } = Joi.validate(obj, schema);
            errors["docs"] = error.details[0].message;
            data["docs"] = "";
        }
        setStateData(data);
        setStateErrors(errors);
    };

    const validateProperty = ({ name, value }) => {
        if (stateSchema && stateSchema[name]) {
            const obj = { [name]: value };
            const schema = { [name]: stateSchema[name] };
            const { error } = Joi.validate(obj, schema);
            return error ? error.details[0].message : null;
        } else {
            return null;
        }
    };

    const validate = () => {
        if (wfTask?.status) return true;

        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(stateData, stateSchema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) {
            const reqItem = stateSchema[item.path[0]];
            if (reqItem?._flags?.presence === "required")
                errors[item.path[0]] = item.message;
        }
        if (Object.keys(errors).length === 0) return false;

        return errors;
    };

    const doSubmit = async (btn, alMsg) => {
        const btnType = btn.name;
        setCurrentButtonMessage(alMsg);
        setBtnProcessStatus(true);
        setCurrentButtonType(btnType);
        if (wfTaskType === "form") {
            handleNextTask(stateData);
        }
        else {
            const btnType = btn.name;
            const processId = btn.dataset.process;
            Object.keys(stateData).forEach(function (keyValue) {
                const dd = keyValue.split(".");
                if (dd.length > 1) {
                    if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                        if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                            var item = stateData[keyValue];
                            if (Array.isArray(item))
                                aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                            else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                        }
                }
            });

            const appShortName = Object.keys(aWorkfinityApp)[1];
            aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
            const frmData = new FormData();
            frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
            frmData.append("workItem", JSON.stringify(wfTask));
            frmData.append("upDocs", JSON.stringify(documents));
            documents.map((file, key) =>
                frmData.append("files[" + key + "]", file.file)
            );

            if (documentInfo) {
                frmData.append("docType", documentInfo.docType);
                frmData.append("updType", documentInfo.updType);
                frmData.append("message", documentInfo.message);
            }

            dispatch(saveBprmForm(frmData));

            if (wfTaskType === "viewForm") {
                handleNextTask(frmData);
            }
            else if (btnType !== "save" && btnType !== "saveAndExit" && wfTask?.wiid > 0) {
                setSaveBtnType(btnType);
                setIsTaskForm(true);
            }
        }
    }

    useEffect(() => {
        if (taskFormSavedStatusSelector && isTaskForm) {
            dispatch(workflowTaskDone(wfTask))
            //dispatch(taskFormSaved(false))
            //setIsTaskForm(false);
            //setSaveBtnType("");
            //handleNextTask(saveBtnType);
            //setBtnProcessStatus(false)
        }
        // else if (taskFormSavedStatusSelector) {
        //     //setIsTaskForm(false);
        //     //setSaveBtnType("");
        //     //dispatch(taskFormSaved(false))
        //     //setBtnProcessStatus(false);
        // }

        if (currentButtonMessage !== "") {
            //getAlert("", currentButtonMessage, "success");
            getAlertWithOk("", currentButtonMessage, "success", () => {
                setTimeout(() => {
                    handleNextTask(currentButtonType);
                }, 1000);
            });
            setCurrentButtonMessage("");
            setCurrentButtonType("");
            setSaveBtnType("");
            setBtnProcessStatus(false);
            setIsTaskForm(false);
            dispatch(taskFormSaved(false))

        }

    }, [taskFormSavedStatusSelector])

    useEffect(() => {
        if (taskDoneStatusSelector) {
            dispatch(taskDone({ status: false }));

            if (updatedStateData && updatedStateData !== "")
                updateBprmFormData();

            if (currentButtonMessage !== "") {
                getAlert("", currentButtonMessage, "success");
                setCurrentButtonMessage("");
                setCurrentButtonType("");
            }
            handleNextTask(currentButtonType);
        }
    }, [taskDoneStatusSelector])

    const updateBprmFormData = async () => {
        setBtnUpdateProcess(true);
        const disValus = _.uniq(frmDDTypes);
        Object.keys(stateData).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = stateData[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const currentUser = getCurrentUser();
        const frmData = new FormData();
        frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
        frmData.append("ciid", wfTask.ciid);
        frmData.append("ddTypes", disValus);
        frmData.append("formId", wfTask.formId);
        frmData.append("performerId", currentUser.id);
        frmData.append("userName", currentUser.name);
        dispatch(updateBprmForm(frmData));
    };

    const getEvaluatedValue = async (comp) => {
        const ruleId = comp.rule;
        const data = { ...stateData };
        Object.keys(data).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = data[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(aWorkfinityApp));
        formData.append("appId", 1);
        formData.append("ruleId", ruleId);
        dispatch(executeBprmFormRule(formData));
    };

    useEffect(() => {
        if (ruleAppDataSelector !== "") {
            const appShortName = Object.keys(ruleAppDataSelector)[1];
            const newAWorkfinityAppEntity = ruleAppDataSelector[appShortName];
            const data = { ...stateData };
            if (newAWorkfinityAppEntity !== "") {
                Object.keys(newAWorkfinityAppEntity).forEach(function (keyValue) {
                    if (
                        keyValue !== "@xmlns:xsd" &&
                        keyValue !== "@xmlns:xsi" &&
                        keyValue !== "EntityId"
                    ) {
                        Object.keys(newAWorkfinityAppEntity[keyValue]).forEach(function (
                            keyValue1
                        ) {
                            if (keyValue1 !== "EntityId") {
                                var item = newAWorkfinityAppEntity[keyValue][keyValue1];
                                if (typeof item === "object") {
                                    if (Array.isArray(item))
                                        data[keyValue + "." + keyValue1.replace("@", "")] = item;
                                    else data[keyValue + "." + keyValue1.replace("@", "")] = [item];
                                } else {
                                    data[keyValue + "." + keyValue1.replace("@", "")] = item;
                                }
                            }
                        });
                    }
                });
            }
            setStateData(data);
        }
    }, [ruleAppDataSelector])

    const getSubformTableHeader = (comp) => {
        const tblHd = subformDataType?.filter(
            (x) =>
                x.dataType ===
                comp.attributeType &&
                x.attribute ===
                comp.attributeObject
        );
        if (tblHd.length === 0) return <tr>
            <th>Datatype not found</th>
        </tr>
        return <tr>
            {tblHd[0].itemList.map(item => <th>
                {item.split(".")[1]}
            </th>)}
            {comp.isEdit && <th>Action</th>}
        </tr>
    }

    const getSubformTableBody = (comp) => {
        const dataObj = aWorkfinityAppEntity[comp.attributeType.toLowerCase()][comp.attributeObject];
        if (dataObj && dataObj?.length > 0) {
            return <tr>
                {dataObj.map((obj, key) => {
                    const tblBd = subformDataType?.filter(
                        (x) =>
                            x.dataType ===
                            comp.attributeType &&
                            x.attribute ===
                            comp.attributeObject
                    );

                    if (tblBd.length > 0) {
                        return tblBd[0].itemList.map(item => <td>
                            {obj["@" + item.split(".")[0]]}
                        </td>)
                    }
                    return comp.isEdit && <td>
                        <button
                            className="btn btn-sm btn-outline-default"
                            onClick={() =>
                                handleSubformModalShowHide(
                                    "showHide" +
                                    comp.subform +
                                    "-" +
                                    key
                                )
                            }
                        >
                            Edit
                        </button>
                    </td>
                })}
            </tr>
        }

        return <tr><td>No Data</td></tr>
    }

    const getHighestColNum = (elements) => {
        const col = elements.reduce(function (prev, current) {
            return prev.components.length > current.components.length
                ? prev
                : current;
        });
        return col.components.length;
    }

    const handlePrintPdf = async (event) => {
        // const frmData = new FormData();
        // //console.log(this.refs.printBody.outerHTML);
        // frmData.append("html", this.refs.printBody.outerHTML);
        // const { data } = await http.post(config.PrintTemplate, frmData);
        // let pdfWindow = window.open("");
        // pdfWindow.document.write(
        //   "<iframe width='100%' height='100%' src='" +
        //     data +
        //     "' style='border: none;'></iframe>"
        // );
    };

    let elements = [];
    if (wfForm?.elementJson) {
        try {
            elements = JSON.parse(wfForm.elementJson);
            // console.log(elements)
        } catch (ex) {
            console.log(ex)
            elements = [];
        }
    }

    const compNum = elements.length > 0 && wfTaskType === "template" ? getHighestColNum(elements) : 0;
    return (
        <fieldset disabled={false}>
            {wfTaskType === "template" &&
                <div id="printBody">
                    <table className="table table-bordered bg-white">
                        {elements.map((col) => (
                            <tr>
                                {col.components.filter(x => x.dataType !== "button").map((comp) => {
                                    let controleId = "";
                                    if (comp.attributeType)
                                        controleId = comp.attributeType?.toLowerCase();

                                    if (comp.attributeObject)
                                        controleId += "." + comp.attributeObject;

                                    return (
                                        <td
                                            style={{ whiteSpace: "pre-wrap" }}
                                            colSpan={
                                                col.components.length === 1
                                                    ? compNum
                                                    : compNum - col.components.length
                                            }
                                        >
                                            {/* {this.rendorHtmlComponent(comp)} */}
                                            {comp.dataType === "label" &&
                                                <Label comp={comp} controleId={controleId} stateData={stateData} />}
                                            {comp.dataType === "textBox" &&
                                                <TextBox
                                                    comp={comp}
                                                    controleId={controleId}
                                                    stateData={stateData}
                                                    stateErrors={stateErrors}
                                                    stateSchema={stateSchema}
                                                    codeIsVerified={codeIsVerified}
                                                    isDisabled={isDisabled}
                                                    handleChange={handleChange}
                                                    handeOnChange={handeOnChange}
                                                    getEvaluatedValue={getEvaluatedValue}
                                                />}
                                            {comp.dataType === "multiLineBox" && <Multiline
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                encryptionDecryptions={encryptionDecryptions}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                                handleEncryptionDecryption={handleEncryptionDecryption}
                                            />
                                            }
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </table>
                </div>}
            {wfTaskType !== "template" &&
                <div className="row">
                    {elements.map((col) => {
                        let showColData = true;
                        if (col.isVisible) {
                            showColData = false;
                            if (col?.visibleAttributeType && col?.visibleAttributeObject) {
                                const vDd = col?.visibleAttributeType.toLowerCase() + "." + col?.visibleAttributeObject;
                                const vRv = col.visibleRuleValue;
                                const vRd = stateData[vDd];
                                const matches = vRv?.split(',')
                                    .map(v => v.trim().toLowerCase())
                                    .includes(vRd?.trim().toLowerCase());
                                if (matches) showColData = true;
                            }
                        }
                        return showColData && <div className={`col-${col.width} ${col?.cssclass ? col.cssclass : ""}`}>
                            {col.components.map((comp, key) => {
                                let controleId = "";
                                if (comp.attributeType)
                                    controleId = comp.attributeType?.toLowerCase();

                                if (comp.attributeObject)
                                    controleId += "." + comp.attributeObject;

                                if (comp.isRequired && controleId != "" && comp.dataType !== "esign") {
                                    if (comp.label)
                                        stateSchema[controleId] = Joi.string().required().label(comp.label);
                                    else
                                        stateSchema[controleId] = Joi.string().required().label("Field is required");
                                }

                                if (comp.attributeType && frmDDTypes.indexOf(comp.attributeType) === -1) {
                                    frmDDTypes.push(comp.attributeType);
                                }

                                if (comp.dataType === "list") {
                                    const formDD = subformDataType?.filter(
                                        (x) =>
                                            x.dataType ===
                                            comp.attributeType &&
                                            x.attribute ===
                                            comp.attributeObject
                                    );
                                    return (
                                        <React.Fragment>
                                            <SubForm
                                                showHide={stateData["showHide" + comp.subform]}
                                                handleModalShowHide={handleSubformModalShowHide}
                                                title={comp.label}
                                                subFormId={comp.subform}
                                                aWorkfinityAppEntity={aWorkfinityAppEntity}
                                                subFormDataType={comp.attributeType}
                                                subFormAttribute={comp.attributeObject}
                                                handleSubformSave={handleSubformSave}
                                                subformItemIndex={subformItemIndex}
                                                formDD={formDD.length > 0 && formDD[0]}
                                            ></SubForm>
                                            <table
                                                className="table table-bordered"
                                                id={`table-to-xls-${comp.subform}`}
                                            >
                                                <thead className="thead-light">
                                                    {getSubformTableHeader(comp)}
                                                </thead>
                                                <tbody>
                                                    {getSubformTableBody(comp)}
                                                </tbody>
                                            </table>
                                        </React.Fragment>
                                    );
                                } else
                                    if (comp.dataType === "button") {
                                        if (comp.buttonType?.type === "editForm" || comp.buttonType?.type === "subform") {
                                            return <Button comp={comp}
                                                btnProcessStatus={btnProcessStatus}
                                                isDisabled={isDisabled}
                                                setIsDisabled={setIsDisabled}
                                                isEdit={wfForm?.isEdit}
                                            />
                                        }
                                    } else {
                                        if (comp.dataType === "label") {
                                            return <Label comp={comp} controleId={controleId} stateData={stateData} />
                                        }
                                        if (comp.dataType === "textBox") {
                                            return <TextBox
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                stateSchema={stateSchema}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                viewTypeType={viewTypeType}
                                                handleChange={handleChange}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                            />
                                        }

                                        if (comp.dataType === "dropDown") {
                                            return <Dropdown
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                stateCountyCity={stateCountyCity}
                                                setStateCountyCity={setStateCountyCity}
                                                ddTypeCodMngr={ddTypeCodMngr}
                                                setDdTypeCodMngr={setDdTypeCodMngr}
                                                handleChange={handleChange}
                                                handeOnChange={handeOnChange}
                                                allStateList={allStateList}
                                                allCountryList={allCountryList}
                                                setIsCountryStateChanged={setIsCountryStateChanged}
                                            />
                                        }

                                        if (comp.dataType === "date") {
                                            return <Date
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                            />
                                        }

                                        if (comp.dataType === "multiLineBox") {
                                            return <Multiline
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                encryptionDecryptions={encryptionDecryptions}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                                handleEncryptionDecryption={handleEncryptionDecryption}
                                            />
                                        }

                                        if (comp.dataType === "radio") {
                                            return <Radio
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                handeOnChange={handeOnChange}
                                            />
                                        }

                                        if (comp.dataType === "checkBox") {
                                            return <CheckBox
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                                ddTypeCodMngr={ddTypeCodMngr}
                                            />
                                        }

                                        if (comp.dataType === "file") {
                                            return <FileUpload
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                onFileChange={onFileChange}
                                            />
                                        }

                                        if (comp.dataType === "viewFile") {
                                            return <ViewFile controlId={controleId} comp={comp} />
                                        }
                                    }
                            })}
                        </div>
                    }

                    )}
                    <div className="col-md-12">
                        <div className="card shadow-none border">
                            {actionType === "workflow" &&
                                <div className="card-header text-center bg-lighter p-2">
                                    <h4 className="mb-0 text-dark">
                                        <i
                                            className="fa fa-arrow-right mr-2"
                                            aria-hidden="true"
                                        ></i>
                                        WORKFLOW ACTION
                                    </h4>
                                </div>}
                            <div className="card-body p-3">
                                <div className="row">
                                    {!appSummary &&
                                        <div className="col-md-12 text-center">
                                            {elements.map((col) =>
                                                col.components.filter(x => x.dataType === "button").map((comp) => {
                                                    if (comp.buttonType?.type === "editForm" || comp.buttonType?.type === "subform") {
                                                        return;
                                                    }
                                                    if (comp.buttonType?.type)
                                                        return <Button comp={comp}
                                                            btnProcessStatus={btnProcessStatus}
                                                            //setBtnProcessStatus={setBtnProcessStatus}
                                                            isDisabled={isDisabled}
                                                            setIsDisabled={setIsDisabled}
                                                            validate={validate}
                                                            doSubmit={doSubmit}
                                                            isEdit={wfForm?.isEdit}
                                                            currentButtonType={currentButtonType}
                                                        />
                                                })
                                            )}
                                        </div>
                                    }
                                    {appSummary &&
                                        <div className="col-md-12 text-center">
                                            {/* <button
                                                className="btn btn-sm btn-outline-default"
                                                disabled={viewType || btnUpdateProcess}
                                                onClick={() => updateBprmFormData()}
                                            >
                                                {btnUpdateProcess ? <i className="fa fa-spinner fa-spin mr-1"></i>
                                                    : <i className="fa fa-pencil mr-1" aria-hidden="true"></i>}
                                                Update
                                            </button> */}
                                            <MUIButton
                                                variant="outline"
                                                color="inherit"
                                                size="small"
                                                onClick={() => updateBprmFormData()}
                                                disabled={viewType || btnUpdateProcess}
                                                startIcon={
                                                    btnProcessStatus ? (
                                                        <CircularProgress size={16} color="inherit" />
                                                    ) : (
                                                        <EditIcon />
                                                    )
                                                }
                                                sx={{
                                                    "&.Mui-disabled": {
                                                        backgroundColor: "#9e9e9e",
                                                        color: "#333333",
                                                        opacity: 1,
                                                    },
                                                    mr: 1,
                                                    mb: 1,
                                                    textTransform: "none",
                                                    border: "1px solid #172b4d",
                                                    color: "black",
                                                    "&:hover": {
                                                        backgroundColor: "#172b4d",
                                                        color: "white",
                                                        borderColor: "#172b4d",
                                                    },
                                                }}
                                            >
                                                Update
                                            </MUIButton>

                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            {wfTaskType === "template" && <div className="col-md-12 text-center">
                <button className="btn btn-sm btn-outline-default" onClick={handlePrintPdf}>
                    <i className="fa fa-print"></i>  Print
                </button>
            </div>}
        </fieldset>
    )
}